import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  portalMount: {
    position: 'fixed',
    inset: 0,
    zIndex: 1000000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
  },
  surface: {
    width: '800px',
    maxWidth: 'calc(100vw - 48px)',
    minHeight: '386px',
    ...shorthands.border('none'),
    boxSizing: 'border-box',
    position: 'relative',
    margin: 0,
    pointerEvents: 'auto',
    ...shorthands.padding('24px'),
    ...shorthands.borderRadius('8px'),
    boxShadow: '0 32px 64px rgba(0, 0, 0, 0.24), 0 0 8px rgba(0, 0, 0, 0.2)',
    '@media (max-width: 700px)': {
      width: 'calc(100vw - 24px)',
      minHeight: 'auto',
      ...shorthands.padding('16px'),
    },
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap('8px'),
    minHeight: '338px',
    '@media (max-width: 700px)': {
      minHeight: 'auto',
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    ...shorthands.gap('8px'),
    minHeight: '32px',
  },
  title: {
    flex: 1,
    fontSize: '20px',
    lineHeight: '28px',
    fontWeight: tokens.fontWeightSemibold,
  },
  dismissButton: {
    minWidth: '28px',
    minHeight: '32px',
    width: '28px',
    height: '32px',
    ...shorthands.padding('0'),
  },
  content: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    ...shorthands.gap('16px'),
    ...shorthands.padding('16px', '0'),
    minHeight: 0,
  },
  description: {
    width: '100%',
    color: tokens.colorNeutralForeground1,
    fontSize: '14px',
    lineHeight: '20px',
  },
  disclaimer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '154px',
    boxSizing: 'border-box',
    ...shorthands.gap('2px'),
    ...shorthands.padding('12px', '12px', '20px'),
    backgroundColor: '#e8ebfa',
    ...shorthands.borderRadius('6px'),
    boxShadow: '0 1px 1px rgba(0, 0, 0, 0.14), 0 0 1px rgba(0, 0, 0, 0.12)',
    '@media (max-width: 700px)': {
      minHeight: 0,
    },
  },
  disclaimerHeading: {
    fontFamily: 'Arial, sans-serif',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: tokens.fontWeightBold,
  },
  disclaimerText: {
    fontFamily: 'Arial, sans-serif',
    fontSize: '14px',
    lineHeight: '20px',
    whiteSpace: 'pre-wrap',
    overflowWrap: 'anywhere',
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    minHeight: '32px',
    ...shorthands.padding('0'),
  },
  notice: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    ...shorthands.gap('4px'),
    color: tokens.colorNeutralForeground1,
    fontSize: '14px',
    lineHeight: '20px',
  },
  closeButton: {
    minWidth: '59px',
    minHeight: '32px',
    fontSize: '14px',
  },
});